export default __webpack_public_path__ + "static/media/C0062-0.3c36b354.jpg";